import React from 'react';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';

import Icon from '../Icon';
import * as S from './style';

const SocialShare = ({ shareLink, jc, jcT, jcM, ...props }) => {
  const url = shareLink || (typeof window !== `undefined` && window.location.href);
  return (
    <S.Wrapper jc={jc} jcT={jcT} jcM={jcM} {...props}>
      <S.ShareWrapper>
        <TwitterShareButton url={url}>
          <Icon margin="2rem" icon="twitterShare" height="32px" width="32px" />
        </TwitterShareButton>
      </S.ShareWrapper>
      <S.ShareWrapper>
        <FacebookShareButton url={url}>
          <Icon icon="facebookShare" height="32px" width="32px" />
        </FacebookShareButton>
      </S.ShareWrapper>
      <S.ShareWrapper>
        <LinkedinShareButton url={url}>
          <Icon icon="linkedInShare" height="32px" width="32px" />
        </LinkedinShareButton>
      </S.ShareWrapper>
      <S.ShareWrapper>
        <WhatsappShareButton url={url}>
          <Icon icon="whatsAppShare" height="32px" width="32px" />
        </WhatsappShareButton>
      </S.ShareWrapper>
      <S.ShareWrapper>
        <a rel="noopener noreferrer" target="_blank" href={`mailto:?subject=&body=${url}`}>
          <Icon icon="emailShare" height="32px" width="32px" />
        </a>
      </S.ShareWrapper>
    </S.Wrapper>
  );
};

export default SocialShare;
